import * as yup from "yup";
import {
  emailMustBeValidEmail,
  fieldMaxLength,
  fieldMustBePositive,
  nullableNumber,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";

export const userWizardFormSchema = yup
  .object({
    id: yup.number().required().defined(),
    studioId: yup.number().required().defined(),
    email: yup
      .string()
      .email(emailMustBeValidEmail())
      .nullable()
      .trim()
      .max(200)
      .defined(),
    firstName: yup
      .string()
      .required(requiredField("Име"))
      .trim()
      .max(200, fieldMaxLength("Име", 200))
      .defined(),
    lastName: yup
      .string()
      .required(requiredField("Фамилно име"))
      .trim()
      .max(200, fieldMaxLength("Фамилно име", 200))
      .defined(),
    additionalInfo: yup
      .string()
      .nullable()
      .trim()
      .max(200, fieldMaxLength("Допълнителна информация", 200))
      .defined(),
    phoneNumber: yup.string().nullable().trim().max(200).defined(),
    familyId: yup.number().nullable(),
    scheduleVisibilityDaysAhead: yup
      .number()
      .defined()
      .transform(nullableNumber)
      .nullable()
      .min(0)
      .positive(
        fieldMustBePositive(
          "Време, за което да е видим графика за потребителя напред"
        )
      ),
    birthDate: yup
      .date()
      .nullable()
      .max(new Date(), "Датата не може да бъде в бъдещето")
      .typeError("Невалидна дата")
      .defined(),
    fontSizePercent: yup
      .number()
      .defined()
      .min(80, "Минималният размер на шрифта е 80%")
      .max(140, "Максималният размер на шрифта е 140%")
      .required(),
    rfidBandId: yup
      .string()
      .nullable()
      .trim()
      .max(100, fieldMaxLength("RFID / NFC", 100))
      .defined(),
  })
  .required();

export type IUserWizardFormModel = yup.InferType<typeof userWizardFormSchema>;

export const userWizardFormDefaultValues: IUserWizardFormModel = {
  id: 0,
  studioId: -1,
  email: "",
  firstName: "",
  lastName: "",
  additionalInfo: "",
  phoneNumber: "",
  scheduleVisibilityDaysAhead: null,
  birthDate: null,
  familyId: null,
  fontSizePercent: 100,
  rfidBandId: "",
};
